import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import SingleSignOnLoginForm from '../../containers/Login/SingleSignOnLoginForm';
import { singleSignOnLoginRequest } from '../../redux/modules/auth/auth-middleware';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';


class SingleSignOnLoginPage extends Component {
  constructor(props, context) {
    super(props, context);

    const parsedQueryString = QueryString.parse(this.props.location.search);
    let redirectTo = '/';
    if (parsedQueryString.redirect) {
      redirectTo = parsedQueryString.redirect + '?isAutoRedirect=true';
      Object.keys(parsedQueryString).forEach((param) => {
        if (param !== 'redirect') {
          const value = parsedQueryString[param];
          redirectTo += '&' + param + '=' + value;
        }
      });
    }

    this.state = {
      redirectTo,
    };
  }

  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  handleLogin = (singleSignOnIdentificationId) => {
    this.props.dispatch(singleSignOnLoginRequest(singleSignOnIdentificationId, this.state.redirectTo));
  };

  render() {
    return (
      <div>
        <SingleSignOnLoginForm handleLogin={this.handleLogin} />
      </div>
    );
  }
}

SingleSignOnLoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  token: state.token,
  location: ownProps.location,
});

export default connect(mapStateToProps)(SingleSignOnLoginPage);